import {
  TrainingAssignmentDto,
  TrainingAssignmentStatus,
} from '../../../app/services/api/compliance/training';

export const isCompletedAssignment = (status: string | number) => (
  typeof status === 'number'
    ? status === TrainingAssignmentStatus.Completed
    : status.toLowerCase() === 'completed' || parseInt(status) === TrainingAssignmentStatus.Completed
);

export const hasRemainingCourseModules = (
  assignments: TrainingAssignmentDto[],
  currentAssignment: TrainingAssignmentDto,
) => {
  const courseAssignments = assignments.filter(
    assignment => assignment.bundleId === currentAssignment.bundleId,
  );
  const assignedModuleCount = new Set(courseAssignments.map(assignment => assignment.moduleId)).size;
  const bundleModuleCount = currentAssignment.bundleModuleCount ?? assignedModuleCount;
  const moduleIds = new Set(courseAssignments.map(assignment => assignment.moduleId));

  return assignedModuleCount < bundleModuleCount || Array.from(moduleIds).some(
    moduleId => moduleId !== currentAssignment.moduleId
      && !courseAssignments.some(assignment => assignment.moduleId === moduleId
        && isCompletedAssignment(assignment.status)),
  );
};

export const getNextCourseAssignment = (
  assignments: TrainingAssignmentDto[],
  currentAssignment: TrainingAssignmentDto,
) => {
  const currentOrder = currentAssignment.moduleOrder ?? Number.MIN_SAFE_INTEGER;
  const completedModuleIds = new Set(
    assignments
      .filter(assignment => assignment.bundleId === currentAssignment.bundleId)
      .filter(assignment => isCompletedAssignment(assignment.status))
      .map(assignment => assignment.moduleId),
  );

  return assignments
    .filter(assignment => assignment.bundleId === currentAssignment.bundleId)
    .filter(assignment => assignment.moduleId !== currentAssignment.moduleId)
    .filter(assignment => !completedModuleIds.has(assignment.moduleId))
    .filter(assignment => (assignment.moduleOrder ?? Number.MAX_SAFE_INTEGER) > currentOrder)
    .sort((left, right) =>
      (left.moduleOrder ?? Number.MAX_SAFE_INTEGER) - (right.moduleOrder ?? Number.MAX_SAFE_INTEGER)
      || right.id - left.id)[0];
};
